import { useMutation, useQuery } from '@tanstack/react-query';
import inboundNumbersService from '../services/inboundNumbersService';

export const useGetSingleInboundNumber = (
	inboundNumberID: number,
	options?: { isEnabled?: boolean },
) => {
	return useQuery<InboundNumber>({
		queryKey: ['inboundNumber', inboundNumberID],
		queryFn: () =>
			inboundNumbersService.getSingleResource(inboundNumberID, {
				getRelated: 'inboundNumberReservations',
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllInboundNumbers = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<TavoittajaApiResponse<{ inboundNumbers: InboundNumber[] }>>(
		{
			queryKey: ['inboundNumbers'],
			queryFn: () =>
				inboundNumbersService.getAllResources({
					filters: options?.filters,
					getRelated: 'inboundNumberReservations',
				}),
			enabled: options?.isEnabled === false ? false : true,
		},
	);
};

export const useDeleteInboundNumber = () => {
	return useMutation({
		mutationKey: ['inboundNumbers'],
		mutationFn: (id: number) =>
			inboundNumbersService.deleteSingleResource(id),
	});
};

export const useUpdateInboundNumber = () => {
	return useMutation({
		mutationKey: ['inboundNumberUpdate'],
		mutationFn: (data: Partial<UpdateInboundNumberRequest>) =>
			inboundNumbersService.update(data),
	});
};

export const useAddInboundNumber = () => {
	return useMutation({
		mutationKey: ['inboundNumber'],
		mutationFn: (data: AddInboundNumberRequest) =>
			inboundNumbersService.create(data),
	});
};
